/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { WalkthroughLoaderOptions } from "../WalkthroughLoader";

export interface FileLocation {
  id: string;
  start?: number;
  end?: number;
}

export class AnnotationLocationParser {

  public static parseAnnotationLocations(source: string, options: WalkthroughLoaderOptions) {

    let locations = [];
    locations = AnnotationLocationParser.parseSource(source, options);

    return locations;
  }

  public static parseSource(source: string, options: WalkthroughLoaderOptions) {
    const { start, end, identifier } = options;
    const locations: FileLocation[] = [];

    const splitSource = source.split("\n");
    splitSource.forEach((line, index) => {
      if (start.test(line)) {
        const [startResult] = line.match(start)!;
        const id = startResult.match(identifier)![1];
        if (id) {
          let newLocation: FileLocation = { id };
          const current = locations.findIndex((loc) => loc.id === id);

          if (current >= 0) {
            newLocation = { ...newLocation, ...locations.splice(current, 1)[0] };
          }

          // const startLines = locations.filter((loc) => loc.start && loc.start < index + 1).length;
          // const endLines = locations.filter((loc) => loc.end && loc.end < index + 1).length;

          // const offset = startLines + endLines;
          newLocation.start = index + 1 + 1;

          locations.push(newLocation);
        }

      }
      if (end.test(line)) {
        const [endResult] = line.match(end)!;
        const id = endResult.match(identifier)![1];
        if (id) {
          let newLocation: FileLocation = { id };
          const current = locations.findIndex((loc) => loc.id === id);

          if (current >= 0) {
            newLocation = { ...newLocation, ...locations.splice(current, 1)[0] };
          }

          // const startLines = locations.filter((loc) => loc.start && loc.start < index + 1).length;
          // const endLines = locations.filter((loc) => loc.end && loc.end < index + 1).length;

          // const offset = startLines + endLines;

          newLocation.end = index;
          locations.push(newLocation);
        }
      }
    });

    return locations;

  }
}
